<template>
  <div class="ctx-pagination__wrap flex justify-between mt-8 mr-2 ml-2">
    <el-pagination
      class="ctx-pagination"
      layout="prev, pager, next"
      :total="total"
      @current-change="onChange"
      v-model:current-page="page"
      :page-size="pageSize"
      hide-on-single-page
    >
    </el-pagination>

    <div v-if="allowChangePageSize" data-test="pagination-page-size-select">
      <el-select :model-value="pageSize" @change="$emit('updatePageSize', $event)" class="w-20">
        <el-option
          v-for="size in [15, 25, 50, 100]"
          :key="size"
          :label="size"
          :value="size"
        >
        </el-option>
      </el-select>
      <span class="ml-2">per page</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CtxPagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    allowChangePageSize: Boolean
  },
  data () {
    return {
      page: this.currentPage
    }
  },
  emits: ['change', 'updatePageSize'],
  methods: {
    onChange (page) {
      this.$emit('change', page)
    }
  }
}
</script>

<style>
.ctx-pagination {
  border: 2px solid #f2f2f2;
  border-radius: 6px;
  padding: 0;

  .el-pager li,
  .btn-prev,
  .btn-next {
    width: 36px;
    background: #fff;
    height: 38px;
    line-height: 38px;
    transition: background-color .2s, color .2s;
    color: #353535;
    font-size: 14px;

    &:hover {
      color: #353535;
      background-color: #f3eaf2;
    }

    &.active {
      background: #8a2981;
      color: #fff;

      .citizen-m & {
        background: var(--red);
      }
    }
  }

  .btn-prev {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .btn-next {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .more::before {
    line-height: 40px !important;
  }

  &__wrap {
    .el-select {
      .el-input__inner {
        height: 42px;
      }
    }
  }
}
</style>
